var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')

var Schedules = function () {
  // init
  var Schedule = BaseModel.extend({
    urlRoot: Config.api.host + '/schedules',
    idAttribute: '_id',
    defaults: {
    },
    validation: {
    }
  })

  var SchedulesCollection = BaseCollection.extend({
    url: Config.api.host + '/schedules',
    model: Schedule,
    mode: 'infinite', //
    state: {
      pageSize: 50,
      firstPage: 0
    },
    parseLinks: function (resp, xhr) {
      // convert an object to a querystring
      var generateQueryString = function (params) {
        return Object.keys(params).map(function (key) {
          return key + '=' + params[key]
        }).join('&')
      }

      var nextParams = _.clone(xhr.data)

      var linksObject = {
        'next': ''
      }

      if (resp.skip + resp.limit < resp.total) {
        nextParams['$page']++
      }

      linksObject['next'] = this.url + '?' + generateQueryString(nextParams)

      // console.log(this.url)
      return linksObject
    }
  // parseState: function (resp, queryParams, state, options) {
  //   return {
  //     totalRecords: resp.total
  //   }
  // },
  // parse: function (data) {
  //   if (!data.data) return data
  //   return data.data
  // }
  })

  //
  var API = {
    getScheduleEntities: function (options) {
      var fetchParams = {
        reset: true
      // cache: true,
      // prefill: true,
      // expires: false
      }

      if (options) {
        if (options.query) fetchParams.data = options.query
      }

      var schedules = new SchedulesCollection()
      schedules.fetch(fetchParams)

      return schedules
    },
    getScheduleEntity: function (id) {
      var schedule = new Schedule({_id: id})
      schedule.fetch()

      return schedule
    },
    newScheduleEntity: function () {
      return new Schedule()
    }
  }

  App.globalChannel.reply({
    'schedule:entities': API.getScheduleEntities,
    'schedule:entity': API.getScheduleEntity
  })

  App.globalChannel.reply('schedule:entity:edit', function () {
    return API.newScheduleEntity()
  })

  App.globalChannel.reply('schedule:entity:new', function () {
    return API.newScheduleEntity()
  })

  // hmmm

  return {
    Model: Schedule,
    Collection: SchedulesCollection
  }
//
}

module.exports = Schedules



// WEBPACK FOOTER //
// ./js/entities/schedules.js